import { createSelector } from 'reselect'

const userDataSelector = state => state.user.data

const myLibraryUserDataSelector = createSelector(
	[userDataSelector],
	userData => {
		const jwt = userData.jwt

		return {
			jwt,
		}
	}
)

export default myLibraryUserDataSelector
